var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedRacing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_93_490",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V15H12V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_93_490)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_93_490",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 0H0V15H11.9995V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_93_490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 15L0 10.6587V0.691941L0.578081 0.591437C1.85249 0.370233 4.26039 0 5.9995 0C7.73863 0 10.147 0.370233 11.4219 0.591437L12 0.691941V10.6585L6.00023 15.0002L6 15Z",
    fill: "url(#paint0_linear_93_490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99991 14.6339L0.295654 10.5064V0.943171L0.628458 0.88553C1.89093 0.666298 4.27688 0.298035 5.99991 0.298035C7.72294 0.298035 10.1089 0.666298 11.3718 0.88553L11.7047 0.943171V10.5064L6.00041 14.6339",
    fill: "#F0F5FA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5142 1.16022V10.4643L6.00016 14.4546L0.485596 10.4643V1.16022L0.660412 1.12992C1.91556 0.912164 4.28689 0.54538 5.99965 0.54538C7.71246 0.54538 10.084 0.912164 11.3389 1.12992L11.5138 1.16022",
    fill: "url(#paint1_linear_93_490)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92988 8.88668C4.39692 8.52505 4.07777 7.92204 4.07777 7.27146C4.07777 7.01925 4.12507 6.77512 4.2165 6.54236C4.2304 6.5086 4.2443 6.47781 4.26088 6.44433L4.92696 4.90499V3.90686H3.15616V4.89956H3.85298L3.28123 6.22016C3.15348 6.55392 3.0896 6.90988 3.0896 7.27174C3.0896 7.87179 3.26734 8.44945 3.606 8.94283C3.93636 9.42241 4.39156 9.79244 4.92988 10.0055C5.11595 10.0784 5.31023 10.1346 5.50725 10.1681C5.56282 10.1764 5.61817 10.1848 5.67648 10.1932L5.88199 10.2072V9.20047L5.67648 9.18645C5.40997 9.14163 5.15469 9.03789 4.92988 8.8864V8.88668Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31406 3.90387H7.07269V4.90197L7.74172 6.44697C7.75559 6.47776 7.76951 6.51152 7.78343 6.54231C7.87509 6.77214 7.92213 7.01897 7.92213 7.27146C7.92213 7.9193 7.60297 8.52204 7.07 8.88663C6.84524 9.03812 6.58703 9.14182 6.32344 9.18937L6.11816 9.2034V10.2102L6.32344 10.1961C6.38171 10.1904 6.44002 10.1821 6.49267 10.171C6.69261 10.1373 6.88689 10.0813 7.07 10.0084C7.60566 9.79239 8.06381 9.4251 8.39392 8.94575C8.73257 8.45507 8.91033 7.87741 8.91033 7.27467C8.91033 6.87928 8.83254 6.49499 8.68261 6.13341L8.14963 4.89951H8.91006V3.90682H7.31406V3.90412V3.90387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_490",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 15.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3392C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_93_490",
    x1: 5.99993,
    y1: 0.54538,
    x2: 5.99993,
    y2: 14.4546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3392C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedRacing);
export default __webpack_public_path__ + "static/media/united-racing.b9614e3f16bf36b978d3778e3402eba4.svg";
export { ForwardRef as ReactComponent };